import React, { PureComponent } from 'react';

import Modal from '@dbk/ui-modal';
import { createContainer } from '@dbk-legacy/muster/react';
import config from '../../../data/get-settings';
import Button from '@dbk/ui-buttons';
import Text from '@dbk/ui-text';
import './style.css';
import { FormattedMessage } from '@dbk-legacy/format';
import styles from './multi-sign-notification.styles';
import { StyleSheet, View } from 'react-native';
import { ROUTES, PENDING_YOUR_APPROVAL, MULTISIGN_TAB_SELECT } from '../../../../src/constants'

class MultiSignNotification extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            pollingFrequency: null,
            fetchDataObj: {}
        }
        this.pollingInterval = null;
    }

    componentDidUpdate(prevProps, prevState) {
        if (Object.keys(prevProps.notifications.dataNotification).length !== Object.keys(this.props.notifications.dataNotification).length) {
            if (Object.keys(this.props.notifications.dataNotification).length !== 0) {
                this.setState({ fetchDataObj: this.props.notifications.dataNotification })
                if (this.props.notifications.dataNotification.areNewPendingPaymentsAvailable) {
                    this.setState({ showModal: true })
                }
            }
            if (this.props.notifications.isFreshLogin && Object.keys(this.props.notifications.dataNotification).length !== 0) {
                this.pollingInterval = setInterval(async () => { this.props.notifications.fetchMultiSignNotification({ isFreshLogin: false }) }, this.props.notifications.dataNotification.apiCallFrequencyInSec);
                //this.props.notifications.dataNotification.apiCallFrequencyInSec
            }
        }
    }


    componentWillUnmount() {
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
        }
    }

    onDetailViewClicked = () => {
        this.props.changePage(ROUTES.PAYMENT.DASHBOARD);
        this.props.payments.setTabSelectedForMultiUser(MULTISIGN_TAB_SELECT.MULTISIG_APPROVALS);
        this.props.payments.setFilterOptions({});  
        this.props.payments.applyFilter({});
        this.setState({ showModal: false })
    }

    render() {
        const {
            i18n: { messages },
            notifications: { dataNotification, isFreshLogin },
        } = this.props;
        const { fetchDataObj: { notificationCategoryCountDtls, newPendingPaymentsCount } } = this.state
        const pendingPaymentsCount = newPendingPaymentsCount;
        //To show modal after checking t&c modal,tooltip payment modal,discovery modal and truthy count value
        const isShowModal = this.state.showModal && !this.props.terms.isModalOpen && !this.props.alerts.isAlertModalOpen && !this.props.visible && pendingPaymentsCount
        if (isShowModal) {
            return (
                <Modal
                    isActive
                    disableOutsideClick
                    className="multisign-notification-modal"
                    onClose={() => this.setState({ showModal: false })}
                    header={messages['app.payments.popupModalHeader']}
                    content={
                        <div className="multisign-notification-modal__content" style={StyleSheet.flatten(styles.popupContent)}>
                            <div style={StyleSheet.flatten(styles.popupMessage)}>
                                <Text>{messages['app.payments.popupModalTitle']}</Text>
                                <p>
                                    <FormattedMessage
                                        id={'app.payments.popupModalContent'}
                                        values={{ pendingPaymentsCount }} />
                                </p>
                            </div>
                            <div style={StyleSheet.flatten(styles.popupButtonContainer)}>
                                <Button onPress={() => this.onDetailViewClicked()} >{messages['app.payments.confirmationBtn']}</Button>
                            </div>
                        </div>
                    }
                />
            );
        }
    }
}
export default createContainer({
    $queries: {
        screen: {
            online: true
        },
        i18n: {
            messages: true,
        },
        notifications: {
            dataNotification: true,
            isFreshLogin: true,
            fetchMultiSignNotification: { $call: 'fetchMultiSignNotification' }

        },
        changePage: { $call: 'ui.history.push' },
        payments: {
            signingType: true,
            tabSelectedForMultiUser: true,
            setTabSelectedForMultiUser: { $set: 'tabSelectedForMultiUser' },
            multiSignPaymentList: true,
            setFilterOptions: { $set: 'multiSignFilterOptions' },
            applyFilter: { $call: 'applyMultiSignFilter' },
        },
        terms: {
            isModalOpen: true,
        },
        alerts: {
            isAlertModalOpen: true,
        }

    },
})(MultiSignNotification);



